import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var Logo = function Logo() {
  return import('../../components/Logo.vue' /* webpackChunkName: "components/logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentBankingInfo = function AdvancePaymentBankingInfo() {
  return import('../../components/advance-payment/advance-payment-banking-info.vue' /* webpackChunkName: "components/advance-payment-banking-info" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentConfirmation = function AdvancePaymentConfirmation() {
  return import('../../components/advance-payment/advance-payment-confirmation.vue' /* webpackChunkName: "components/advance-payment-confirmation" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentSetup = function AdvancePaymentSetup() {
  return import('../../components/advance-payment/advance-payment-setup.vue' /* webpackChunkName: "components/advance-payment-setup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentStartNow = function AdvancePaymentStartNow() {
  return import('../../components/advance-payment/advance-payment-start-now.vue' /* webpackChunkName: "components/advance-payment-start-now" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentTransferConfirmation = function AdvancePaymentTransferConfirmation() {
  return import('../../components/advance-payment/advance-payment-transfer-confirmation.vue' /* webpackChunkName: "components/advance-payment-transfer-confirmation" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePaymentTransfer = function AdvancePaymentTransfer() {
  return import('../../components/advance-payment/advance-payment-transfer.vue' /* webpackChunkName: "components/advance-payment-transfer" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AdvancePayment = function AdvancePayment() {
  return import('../../components/advance-payment/advance-payment.vue' /* webpackChunkName: "components/advance-payment" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppAddNewMember = function AppsAppAddNewMember() {
  return import('../../components/apps/app-add-new-member.vue' /* webpackChunkName: "components/apps-app-add-new-member" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppCustomerReview = function AppsAppCustomerReview() {
  return import('../../components/apps/app-customer-review.vue' /* webpackChunkName: "components/apps-app-customer-review" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppDetailSection = function AppsAppDetailSection() {
  return import('../../components/apps/app-detail-section.vue' /* webpackChunkName: "components/apps-app-detail-section" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppMembersSection = function AppsAppMembersSection() {
  return import('../../components/apps/app-members-section.vue' /* webpackChunkName: "components/apps-app-members-section" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverConfigurationItem = function AppsAppReceiverConfigurationItem() {
  return import('../../components/apps/app-receiver-configuration-item.vue' /* webpackChunkName: "components/apps-app-receiver-configuration-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverConfiguration = function AppsAppReceiverConfiguration() {
  return import('../../components/apps/app-receiver-configuration.vue' /* webpackChunkName: "components/apps-app-receiver-configuration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverHealthIndexConfigurationItem = function AppsAppReceiverHealthIndexConfigurationItem() {
  return import('../../components/apps/app-receiver-health-index-configuration-item.vue' /* webpackChunkName: "components/apps-app-receiver-health-index-configuration-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverHealthIndexConfiguration = function AppsAppReceiverHealthIndexConfiguration() {
  return import('../../components/apps/app-receiver-health-index-configuration.vue' /* webpackChunkName: "components/apps-app-receiver-health-index-configuration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverKotMarketing = function AppsAppReceiverKotMarketing() {
  return import('../../components/apps/app-receiver-kot-marketing.vue' /* webpackChunkName: "components/apps-app-receiver-kot-marketing" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverPrint = function AppsAppReceiverPrint() {
  return import('../../components/apps/app-receiver-print.vue' /* webpackChunkName: "components/apps-app-receiver-print" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReceiverUserAccess = function AppsAppReceiverUserAccess() {
  return import('../../components/apps/app-receiver-user-access.vue' /* webpackChunkName: "components/apps-app-receiver-user-access" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppRecieverPrinterSection = function AppsAppRecieverPrinterSection() {
  return import('../../components/apps/app-reciever-printer-section.vue' /* webpackChunkName: "components/apps-app-reciever-printer-section" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppRecieverSubscriptionPlan = function AppsAppRecieverSubscriptionPlan() {
  return import('../../components/apps/app-reciever-subscription-plan.vue' /* webpackChunkName: "components/apps-app-reciever-subscription-plan" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppReciever = function AppsAppReciever() {
  return import('../../components/apps/app-reciever.vue' /* webpackChunkName: "components/apps-app-reciever" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppSubscribeBtn = function AppsAppSubscribeBtn() {
  return import('../../components/apps/app-subscribe-btn.vue' /* webpackChunkName: "components/apps-app-subscribe-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppTile = function AppsAppTile() {
  return import('../../components/apps/app-tile.vue' /* webpackChunkName: "components/apps-app-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsAppWhatsappConfiguration = function AppsAppWhatsappConfiguration() {
  return import('../../components/apps/app-whatsapp-configuration.vue' /* webpackChunkName: "components/apps-app-whatsapp-configuration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsDetailHeaderRow = function AppsDetailHeaderRow() {
  return import('../../components/apps/apps-detail-header-row.vue' /* webpackChunkName: "components/apps-detail-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsHeaderMenuFormatter = function AppsHeaderMenuFormatter() {
  return import('../../components/apps/apps-header-menu-formatter.vue' /* webpackChunkName: "components/apps-header-menu-formatter" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsHeaderRow = function AppsHeaderRow() {
  return import('../../components/apps/apps-header-row.vue' /* webpackChunkName: "components/apps-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsHeaderSearchField = function AppsHeaderSearchField() {
  return import('../../components/apps/apps-header-search-field.vue' /* webpackChunkName: "components/apps-header-search-field" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsHeaderViewToggler = function AppsHeaderViewToggler() {
  return import('../../components/apps/apps-header-view-toggler.vue' /* webpackChunkName: "components/apps-header-view-toggler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsMyApps = function AppsMyApps() {
  return import('../../components/apps/apps-my-apps.vue' /* webpackChunkName: "components/apps-my-apps" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsNotification = function AppsNotification() {
  return import('../../components/apps/apps-notification.vue' /* webpackChunkName: "components/apps-notification" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsRecommendedForYou = function AppsRecommendedForYou() {
  return import('../../components/apps/apps-recommended-for-you.vue' /* webpackChunkName: "components/apps-recommended-for-you" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var AppsSystemDefaultApps = function AppsSystemDefaultApps() {
  return import('../../components/apps/apps-system-default-apps.vue' /* webpackChunkName: "components/apps-system-default-apps" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var BulkEditHeaderRow = function BulkEditHeaderRow() {
  return import('../../components/bulk-edit/bulk-edit-header-row.vue' /* webpackChunkName: "components/bulk-edit-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var BulkEditItemList = function BulkEditItemList() {
  return import('../../components/bulk-edit/bulk-edit-item-list.vue' /* webpackChunkName: "components/bulk-edit-item-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var BulkEditModifyForm = function BulkEditModifyForm() {
  return import('../../components/bulk-edit/bulk-edit-modify-form.vue' /* webpackChunkName: "components/bulk-edit-modify-form" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var BulkEditPriceConfiguration = function BulkEditPriceConfiguration() {
  return import('../../components/bulk-edit/bulk-edit-price-configuration.vue' /* webpackChunkName: "components/bulk-edit-price-configuration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var BulkEdit = function BulkEdit() {
  return import('../../components/bulk-edit/bulk-edit.vue' /* webpackChunkName: "components/bulk-edit" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CartAddToCart = function CartAddToCart() {
  return import('../../components/cart/add-to-cart.vue' /* webpackChunkName: "components/cart-add-to-cart" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CartDeliveryLocation = function CartDeliveryLocation() {
  return import('../../components/cart/cart-delivery-location.vue' /* webpackChunkName: "components/cart-delivery-location" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CartItem = function CartItem() {
  return import('../../components/cart/cart-item.vue' /* webpackChunkName: "components/cart-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CartPaymentSummary = function CartPaymentSummary() {
  return import('../../components/cart/cart-payment-summary.vue' /* webpackChunkName: "components/cart-payment-summary" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CartOrderSummary = function CartOrderSummary() {
  return import('../../components/cart/order-summary.vue' /* webpackChunkName: "components/cart-order-summary" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ChatBotWidget = function ChatBotWidget() {
  return import('../../components/chat-bot/chatBotWidget.vue' /* webpackChunkName: "components/chat-bot-widget" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ChatMessageCard = function ChatMessageCard() {
  return import('../../components/chat-bot/chatMessageCard.vue' /* webpackChunkName: "components/chat-message-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAnimatedArrowWithText = function CommonAnimatedArrowWithText() {
  return import('../../components/common/animated-arrow-with-text.vue' /* webpackChunkName: "components/common-animated-arrow-with-text" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAnimatedCheckMark = function CommonAnimatedCheckMark() {
  return import('../../components/common/animated-check-mark.vue' /* webpackChunkName: "components/common-animated-check-mark" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAppBarMobile = function CommonAppBarMobile() {
  return import('../../components/common/app-bar-mobile.vue' /* webpackChunkName: "components/common-app-bar-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAppBar = function CommonAppBar() {
  return import('../../components/common/app-bar.vue' /* webpackChunkName: "components/common-app-bar" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAppVolumeHandler = function CommonAppVolumeHandler() {
  return import('../../components/common/app-volume-handler.vue' /* webpackChunkName: "components/common-app-volume-handler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAudioAlert = function CommonAudioAlert() {
  return import('../../components/common/audio-alert.vue' /* webpackChunkName: "components/common-audio-alert" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonBackBottonWithBlankLogo = function CommonBackBottonWithBlankLogo() {
  return import('../../components/common/back-botton-with-blank-logo.vue' /* webpackChunkName: "components/common-back-botton-with-blank-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonBackButtonFullHeight = function CommonBackButtonFullHeight() {
  return import('../../components/common/back-button-full-height.vue' /* webpackChunkName: "components/common-back-button-full-height" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonBackButtonOutlined = function CommonBackButtonOutlined() {
  return import('../../components/common/back-button-outlined.vue' /* webpackChunkName: "components/common-back-button-outlined" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonBrandAvatarWithColor = function CommonBrandAvatarWithColor() {
  return import('../../components/common/brand-avatar-with-color.vue' /* webpackChunkName: "components/common-brand-avatar-with-color" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonBrandHamburgerMenu = function CommonBrandHamburgerMenu() {
  return import('../../components/common/brand-hamburger-menu.vue' /* webpackChunkName: "components/common-brand-hamburger-menu" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonChannelIntegrationBanner = function CommonChannelIntegrationBanner() {
  return import('../../components/common/channel-integration-banner.vue' /* webpackChunkName: "components/common-channel-integration-banner" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonChatbotButton = function CommonChatbotButton() {
  return import('../../components/common/chatbot-button.vue' /* webpackChunkName: "components/common-chatbot-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonCoachMarkToolTip = function CommonCoachMarkToolTip() {
  return import('../../components/common/coach-mark-tool-tip.vue' /* webpackChunkName: "components/common-coach-mark-tool-tip" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonAccessDenied = function CommonAccessDenied() {
  return import('../../components/common/common-access-denied.vue' /* webpackChunkName: "components/common-access-denied" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonHeaderBlackBackground = function CommonHeaderBlackBackground() {
  return import('../../components/common/common-header-black-background.vue' /* webpackChunkName: "components/common-header-black-background" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonHeaderMobile = function CommonHeaderMobile() {
  return import('../../components/common/common-header-mobile.vue' /* webpackChunkName: "components/common-header-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonHeader = function CommonHeader() {
  return import('../../components/common/common-header.vue' /* webpackChunkName: "components/common-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonMenuItemPriceLabel = function CommonMenuItemPriceLabel() {
  return import('../../components/common/common-menu-item-price-label.vue' /* webpackChunkName: "components/common-menu-item-price-label" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonOrderDialogs = function CommonOrderDialogs() {
  return import('../../components/common/common-order-dialogs.vue' /* webpackChunkName: "components/common-order-dialogs" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonToast = function CommonToast() {
  return import('../../components/common/common-toast.vue' /* webpackChunkName: "components/common-toast" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonUserAvatar = function CommonUserAvatar() {
  return import('../../components/common/common-user-avatar.vue' /* webpackChunkName: "components/common-user-avatar" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonCommunicationButton = function CommonCommunicationButton() {
  return import('../../components/common/communication-button.vue' /* webpackChunkName: "components/common-communication-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonCountrycodeWithTextfield = function CommonCountrycodeWithTextfield() {
  return import('../../components/common/countrycode-with-textfield.vue' /* webpackChunkName: "components/common-countrycode-with-textfield" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonCurrencyConverter = function CommonCurrencyConverter() {
  return import('../../components/common/currency-converter.vue' /* webpackChunkName: "components/common-currency-converter" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonDialogCircleCloseBtn = function CommonDialogCircleCloseBtn() {
  return import('../../components/common/dialog-circle-close-btn.vue' /* webpackChunkName: "components/common-dialog-circle-close-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonDialogCloseBtn = function CommonDialogCloseBtn() {
  return import('../../components/common/dialog-close-btn.vue' /* webpackChunkName: "components/common-dialog-close-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonEllipcisedText = function CommonEllipcisedText() {
  return import('../../components/common/ellipcised-text.vue' /* webpackChunkName: "components/common-ellipcised-text" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonEmergencyLoader = function CommonEmergencyLoader() {
  return import('../../components/common/emergency-loader.vue' /* webpackChunkName: "components/common-emergency-loader" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonFoapsLogo = function CommonFoapsLogo() {
  return import('../../components/common/foaps-logo.vue' /* webpackChunkName: "components/common-foaps-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonFooterMobile = function CommonFooterMobile() {
  return import('../../components/common/footer-mobile.vue' /* webpackChunkName: "components/common-footer-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonFreshWorkWidget = function CommonFreshWorkWidget() {
  return import('../../components/common/fresh-work-widget.vue' /* webpackChunkName: "components/common-fresh-work-widget" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonInternetStatusBanner = function CommonInternetStatusBanner() {
  return import('../../components/common/internet-status-banner.vue' /* webpackChunkName: "components/common-internet-status-banner" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonKotMarketingQrCode = function CommonKotMarketingQrCode() {
  return import('../../components/common/kot-marketing-qr-code.vue' /* webpackChunkName: "components/common-kot-marketing-qr-code" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonLogoutAvatar = function CommonLogoutAvatar() {
  return import('../../components/common/logout-avatar.vue' /* webpackChunkName: "components/common-logout-avatar" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonMakePayment = function CommonMakePayment() {
  return import('../../components/common/make-payment.vue' /* webpackChunkName: "components/common-make-payment" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonMobileEmailTab = function CommonMobileEmailTab() {
  return import('../../components/common/mobile-email-tab.vue' /* webpackChunkName: "components/common-mobile-email-tab" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonNoDataLabel = function CommonNoDataLabel() {
  return import('../../components/common/no-data-label.vue' /* webpackChunkName: "components/common-no-data-label" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonNotificationBannerItem = function CommonNotificationBannerItem() {
  return import('../../components/common/notification-banner-item.vue' /* webpackChunkName: "components/common-notification-banner-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonNotificationBanner = function CommonNotificationBanner() {
  return import('../../components/common/notification-banner.vue' /* webpackChunkName: "components/common-notification-banner" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonOnHoldButton = function CommonOnHoldButton() {
  return import('../../components/common/on-hold-button.vue' /* webpackChunkName: "components/common-on-hold-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonOrderDurationGraph = function CommonOrderDurationGraph() {
  return import('../../components/common/order-duration-graph.vue' /* webpackChunkName: "components/common-order-duration-graph" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonOtpVerification = function CommonOtpVerification() {
  return import('../../components/common/otp-verification.vue' /* webpackChunkName: "components/common-otp-verification" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonOutlinedBtn = function CommonOutlinedBtn() {
  return import('../../components/common/outlined-btn.vue' /* webpackChunkName: "components/common-outlined-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonPairedChannelRow = function CommonPairedChannelRow() {
  return import('../../components/common/paired-channel-row.vue' /* webpackChunkName: "components/common-paired-channel-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonProfilePicturePreviewAndUpdate = function CommonProfilePicturePreviewAndUpdate() {
  return import('../../components/common/profile-picture-preview-and-update.vue' /* webpackChunkName: "components/common-profile-picture-preview-and-update" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonPushNotification = function CommonPushNotification() {
  return import('../../components/common/push-notification.vue' /* webpackChunkName: "components/common-push-notification" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonPwaUpdate = function CommonPwaUpdate() {
  return import('../../components/common/pwa-update.vue' /* webpackChunkName: "components/common-pwa-update" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonQrCode = function CommonQrCode() {
  return import('../../components/common/qr-code.vue' /* webpackChunkName: "components/common-qr-code" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonQzPrintV2 = function CommonQzPrintV2() {
  return import('../../components/common/qz-print-v2.vue' /* webpackChunkName: "components/common-qz-print-v2" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonQzPrint = function CommonQzPrint() {
  return import('../../components/common/qz-print.vue' /* webpackChunkName: "components/common-qz-print" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonRefreshButton = function CommonRefreshButton() {
  return import('../../components/common/refresh-button.vue' /* webpackChunkName: "components/common-refresh-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonReportsButton = function CommonReportsButton() {
  return import('../../components/common/reports-button.vue' /* webpackChunkName: "components/common-reports-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonRiderDetailsTemplate = function CommonRiderDetailsTemplate() {
  return import('../../components/common/rider-details-template.vue' /* webpackChunkName: "components/common-rider-details-template" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonRippleIndicator = function CommonRippleIndicator() {
  return import('../../components/common/ripple-indicator.vue' /* webpackChunkName: "components/common-ripple-indicator" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonSettingsButton = function CommonSettingsButton() {
  return import('../../components/common/settings-button.vue' /* webpackChunkName: "components/common-settings-button" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonStoreOnlineOfflineBanner = function CommonStoreOnlineOfflineBanner() {
  return import('../../components/common/store-online-offline-banner.vue' /* webpackChunkName: "components/common-store-online-offline-banner" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonSubscriptionBanner = function CommonSubscriptionBanner() {
  return import('../../components/common/subscription-banner.vue' /* webpackChunkName: "components/common-subscription-banner" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonTextBubbleAlert = function CommonTextBubbleAlert() {
  return import('../../components/common/text-bubble-alert.vue' /* webpackChunkName: "components/common-text-bubble-alert" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonUnpairedChannelRow = function CommonUnpairedChannelRow() {
  return import('../../components/common/unpaired-channel-row.vue' /* webpackChunkName: "components/common-unpaired-channel-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonWatchVideo = function CommonWatchVideo() {
  return import('../../components/common/watch-video.vue' /* webpackChunkName: "components/common-watch-video" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommonWelcomeUserScreen = function CommonWelcomeUserScreen() {
  return import('../../components/common/welcome-user-screen.vue' /* webpackChunkName: "components/common-welcome-user-screen" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommunicationChatList = function CommunicationChatList() {
  return import('../../components/communication/communication-chat-list.vue' /* webpackChunkName: "components/communication-chat-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommunicationChatViewMsgItem = function CommunicationChatViewMsgItem() {
  return import('../../components/communication/communication-chat-view-msg-item.vue' /* webpackChunkName: "components/communication-chat-view-msg-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommunicationChatViewMsgList = function CommunicationChatViewMsgList() {
  return import('../../components/communication/communication-chat-view-msg-list.vue' /* webpackChunkName: "components/communication-chat-view-msg-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommunicationChatView = function CommunicationChatView() {
  return import('../../components/communication/communication-chat-view.vue' /* webpackChunkName: "components/communication-chat-view" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var CommunicationTabHeader = function CommunicationTabHeader() {
  return import('../../components/communication/communication-tab-header.vue' /* webpackChunkName: "components/communication-tab-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var Communication = function Communication() {
  return import('../../components/communication/communication.vue' /* webpackChunkName: "components/communication" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DeliveryAddressChooseDeliveryLocation = function DeliveryAddressChooseDeliveryLocation() {
  return import('../../components/delivery-address/choose-delivery-location.vue' /* webpackChunkName: "components/delivery-address-choose-delivery-location" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DeliveryAddress = function DeliveryAddress() {
  return import('../../components/delivery-address/delivery-address.vue' /* webpackChunkName: "components/delivery-address" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAddNewBrandDialog = function DialogsAddNewBrandDialog() {
  return import('../../components/dialogs/add-new-brand-dialog.vue' /* webpackChunkName: "components/dialogs-add-new-brand-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAddNewKotPrinterDialog = function DialogsAddNewKotPrinterDialog() {
  return import('../../components/dialogs/add-new-kot-printer-dialog.vue' /* webpackChunkName: "components/dialogs-add-new-kot-printer-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAddToCartDialog = function DialogsAddToCartDialog() {
  return import('../../components/dialogs/add-to-cart-dialog.vue' /* webpackChunkName: "components/dialogs-add-to-cart-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAddedItemCustomisationDialog = function DialogsAddedItemCustomisationDialog() {
  return import('../../components/dialogs/added-item-customisation-dialog.vue' /* webpackChunkName: "components/dialogs-added-item-customisation-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAssignItemsToPrinterDialog = function DialogsAssignItemsToPrinterDialog() {
  return import('../../components/dialogs/assign-items-to-printer-dialog.vue' /* webpackChunkName: "components/dialogs-assign-items-to-printer-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsAvailableBrandsDialog = function DialogsAvailableBrandsDialog() {
  return import('../../components/dialogs/available-brands-dialog.vue' /* webpackChunkName: "components/dialogs-available-brands-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsBatchSettingsDialog = function DialogsBatchSettingsDialog() {
  return import('../../components/dialogs/batch-settings-dialog.vue' /* webpackChunkName: "components/dialogs-batch-settings-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsBrandSwitchDialog = function DialogsBrandSwitchDialog() {
  return import('../../components/dialogs/brand-switch-dialog.vue' /* webpackChunkName: "components/dialogs-brand-switch-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCancelAndAssignNewRiderDialog = function DialogsCancelAndAssignNewRiderDialog() {
  return import('../../components/dialogs/cancel-and-assign-new-rider-dialog.vue' /* webpackChunkName: "components/dialogs-cancel-and-assign-new-rider-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsChooseOutletLocationDialog = function DialogsChooseOutletLocationDialog() {
  return import('../../components/dialogs/choose-outlet-location-dialog.vue' /* webpackChunkName: "components/dialogs-choose-outlet-location-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsChooseUserLocationDialog = function DialogsChooseUserLocationDialog() {
  return import('../../components/dialogs/choose-user-location-dialog.vue' /* webpackChunkName: "components/dialogs-choose-user-location-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCommonInfoDialog = function DialogsCommonInfoDialog() {
  return import('../../components/dialogs/common-info-dialog.vue' /* webpackChunkName: "components/dialogs-common-info-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsConfirmationDialog = function DialogsConfirmationDialog() {
  return import('../../components/dialogs/confirmation-dialog.vue' /* webpackChunkName: "components/dialogs-confirmation-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCreateEditAddonDialog = function DialogsCreateEditAddonDialog() {
  return import('../../components/dialogs/create-edit-addon-dialog.vue' /* webpackChunkName: "components/dialogs-create-edit-addon-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCreateEditCategoryDialog = function DialogsCreateEditCategoryDialog() {
  return import('../../components/dialogs/create-edit-category-dialog.vue' /* webpackChunkName: "components/dialogs-create-edit-category-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCreateEditSubCategoryDialog = function DialogsCreateEditSubCategoryDialog() {
  return import('../../components/dialogs/create-edit-sub-category-dialog.vue' /* webpackChunkName: "components/dialogs-create-edit-sub-category-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsCreateModifyKotDialog = function DialogsCreateModifyKotDialog() {
  return import('../../components/dialogs/create-modify-kot-dialog.vue' /* webpackChunkName: "components/dialogs-create-modify-kot-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsDeleteCategoryDialog = function DialogsDeleteCategoryDialog() {
  return import('../../components/dialogs/delete-category-dialog.vue' /* webpackChunkName: "components/dialogs-delete-category-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsDisintergrationReasonDialogContent = function DialogsDisintergrationReasonDialogContent() {
  return import('../../components/dialogs/disintergration-reason-dialog-content.vue' /* webpackChunkName: "components/dialogs-disintergration-reason-dialog-content" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsDisintergrationReasonDialog = function DialogsDisintergrationReasonDialog() {
  return import('../../components/dialogs/disintergration-reason-dialog.vue' /* webpackChunkName: "components/dialogs-disintergration-reason-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsInfoDialogMobile = function DialogsInfoDialogMobile() {
  return import('../../components/dialogs/info-dialog-mobile.vue' /* webpackChunkName: "components/dialogs-info-dialog-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsIntegrateBrandsToChannelDialog = function DialogsIntegrateBrandsToChannelDialog() {
  return import('../../components/dialogs/integrate-brands-to-channel-dialog.vue' /* webpackChunkName: "components/dialogs-integrate-brands-to-channel-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsIntegrateBrandsToChannelsMobileDialog = function DialogsIntegrateBrandsToChannelsMobileDialog() {
  return import('../../components/dialogs/integrate-brands-to-channels-mobile-dialog.vue' /* webpackChunkName: "components/dialogs-integrate-brands-to-channels-mobile-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsInvoiceDialog = function DialogsInvoiceDialog() {
  return import('../../components/dialogs/invoice-dialog.vue' /* webpackChunkName: "components/dialogs-invoice-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsInvoiceTransactionHistoryDialog = function DialogsInvoiceTransactionHistoryDialog() {
  return import('../../components/dialogs/invoice-transaction-history-dialog.vue' /* webpackChunkName: "components/dialogs-invoice-transaction-history-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsItemWiseSalesDetailDialog = function DialogsItemWiseSalesDetailDialog() {
  return import('../../components/dialogs/item-wise-sales-detail-dialog.vue' /* webpackChunkName: "components/dialogs-item-wise-sales-detail-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsLocationPermissionDialog = function DialogsLocationPermissionDialog() {
  return import('../../components/dialogs/location-permission-dialog.vue' /* webpackChunkName: "components/dialogs-location-permission-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsManualOrderCompletionDialog = function DialogsManualOrderCompletionDialog() {
  return import('../../components/dialogs/manual-order-completion-dialog.vue' /* webpackChunkName: "components/dialogs-manual-order-completion-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMasterKotPrinterConfigDialog = function DialogsMasterKotPrinterConfigDialog() {
  return import('../../components/dialogs/master-kot-printer-config-dialog.vue' /* webpackChunkName: "components/dialogs-master-kot-printer-config-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuAddItemComboDialog = function DialogsMenuAddItemComboDialog() {
  return import('../../components/dialogs/menu-add-item-combo-dialog.vue' /* webpackChunkName: "components/dialogs-menu-add-item-combo-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuAssistanceDialog = function DialogsMenuAssistanceDialog() {
  return import('../../components/dialogs/menu-assistance-dialog.vue' /* webpackChunkName: "components/dialogs-menu-assistance-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuCreateComboDialog = function DialogsMenuCreateComboDialog() {
  return import('../../components/dialogs/menu-create-combo-dialog.vue' /* webpackChunkName: "components/dialogs-menu-create-combo-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuDisableItemDialog = function DialogsMenuDisableItemDialog() {
  return import('../../components/dialogs/menu-disable-item-dialog.vue' /* webpackChunkName: "components/dialogs-menu-disable-item-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuItemAddVariantDialog = function DialogsMenuItemAddVariantDialog() {
  return import('../../components/dialogs/menu-item-add-variant-dialog.vue' /* webpackChunkName: "components/dialogs-menu-item-add-variant-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuItemCreateChoiceGroupDialog = function DialogsMenuItemCreateChoiceGroupDialog() {
  return import('../../components/dialogs/menu-item-create-choice-group-dialog.vue' /* webpackChunkName: "components/dialogs-menu-item-create-choice-group-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuItemDeleteConfirmationDialog = function DialogsMenuItemDeleteConfirmationDialog() {
  return import('../../components/dialogs/menu-item-delete-confirmation-dialog.vue' /* webpackChunkName: "components/dialogs-menu-item-delete-confirmation-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuOrderBackToWhatsappDialog = function DialogsMenuOrderBackToWhatsappDialog() {
  return import('../../components/dialogs/menu-order-back-to-whatsapp-dialog.vue' /* webpackChunkName: "components/dialogs-menu-order-back-to-whatsapp-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuOrderItemUnavailableDialog = function DialogsMenuOrderItemUnavailableDialog() {
  return import('../../components/dialogs/menu-order-item-unavailable-dialog.vue' /* webpackChunkName: "components/dialogs-menu-order-item-unavailable-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuOrderOutOfDeliveryRadius = function DialogsMenuOrderOutOfDeliveryRadius() {
  return import('../../components/dialogs/menu-order-out-of-delivery-radius.vue' /* webpackChunkName: "components/dialogs-menu-order-out-of-delivery-radius" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuPhotoUploadDialog = function DialogsMenuPhotoUploadDialog() {
  return import('../../components/dialogs/menu-photo-upload-dialog.vue' /* webpackChunkName: "components/dialogs-menu-photo-upload-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadAddPackagingChargeDialog = function DialogsMenuUploadAddPackagingChargeDialog() {
  return import('../../components/dialogs/menu-upload-add-packaging-charge-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-add-packaging-charge-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadAddVariantDialog = function DialogsMenuUploadAddVariantDialog() {
  return import('../../components/dialogs/menu-upload-add-variant-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-add-variant-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadCharacterLimitDialog = function DialogsMenuUploadCharacterLimitDialog() {
  return import('../../components/dialogs/menu-upload-character-limit-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-character-limit-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadCreateAddonDialog = function DialogsMenuUploadCreateAddonDialog() {
  return import('../../components/dialogs/menu-upload-create-addon-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-create-addon-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadCreateChoiceDialog = function DialogsMenuUploadCreateChoiceDialog() {
  return import('../../components/dialogs/menu-upload-create-choice-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-create-choice-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadCreateChoiceGroupDialog = function DialogsMenuUploadCreateChoiceGroupDialog() {
  return import('../../components/dialogs/menu-upload-create-choice-group-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-create-choice-group-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadDescriptionWarningDialog = function DialogsMenuUploadDescriptionWarningDialog() {
  return import('../../components/dialogs/menu-upload-description-warning-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-description-warning-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadEmptyAddonDialog = function DialogsMenuUploadEmptyAddonDialog() {
  return import('../../components/dialogs/menu-upload-empty-addon-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-empty-addon-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadFailedToImportDialog = function DialogsMenuUploadFailedToImportDialog() {
  return import('../../components/dialogs/menu-upload-failed-to-import-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-failed-to-import-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadInfoDialog = function DialogsMenuUploadInfoDialog() {
  return import('../../components/dialogs/menu-upload-info-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-info-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadPackagingChargeEligibleItemsDialog = function DialogsMenuUploadPackagingChargeEligibleItemsDialog() {
  return import('../../components/dialogs/menu-upload-packaging-charge-eligible-items-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-packaging-charge-eligible-items-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadPriceMissingDialog = function DialogsMenuUploadPriceMissingDialog() {
  return import('../../components/dialogs/menu-upload-price-missing-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-price-missing-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadPriceModifyDialog = function DialogsMenuUploadPriceModifyDialog() {
  return import('../../components/dialogs/menu-upload-price-modify-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-price-modify-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsMenuUploadUnassignedImageWarningDialog = function DialogsMenuUploadUnassignedImageWarningDialog() {
  return import('../../components/dialogs/menu-upload-unassigned-image-warning-dialog.vue' /* webpackChunkName: "components/dialogs-menu-upload-unassigned-image-warning-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsModifiedOrderDialog = function DialogsModifiedOrderDialog() {
  return import('../../components/dialogs/modified-order-dialog.vue' /* webpackChunkName: "components/dialogs-modified-order-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsModifyPrinterDialog = function DialogsModifyPrinterDialog() {
  return import('../../components/dialogs/modify-printer-dialog.vue' /* webpackChunkName: "components/dialogs-modify-printer-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOnboardingCompletedDialog = function DialogsOnboardingCompletedDialog() {
  return import('../../components/dialogs/onboarding-completed-dialog.vue' /* webpackChunkName: "components/dialogs-onboarding-completed-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderHighTemperatureDialog = function DialogsOrderHighTemperatureDialog() {
  return import('../../components/dialogs/order-high-temperature-dialog.vue' /* webpackChunkName: "components/dialogs-order-high-temperature-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderHighTemperatureResponseMsgDialog = function DialogsOrderHighTemperatureResponseMsgDialog() {
  return import('../../components/dialogs/order-high-temperature-response-msg-dialog.vue' /* webpackChunkName: "components/dialogs-order-high-temperature-response-msg-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderNewActionDialog = function DialogsOrderNewActionDialog() {
  return import('../../components/dialogs/order-new-action-dialog.vue' /* webpackChunkName: "components/dialogs-order-new-action-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderPickedUpActionDialog = function DialogsOrderPickedUpActionDialog() {
  return import('../../components/dialogs/order-picked-up-action-dialog.vue' /* webpackChunkName: "components/dialogs-order-picked-up-action-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderReadyForDeliveryActionDialog = function DialogsOrderReadyForDeliveryActionDialog() {
  return import('../../components/dialogs/order-ready-for-delivery-action-dialog.vue' /* webpackChunkName: "components/dialogs-order-ready-for-delivery-action-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderRejectReasonDialog = function DialogsOrderRejectReasonDialog() {
  return import('../../components/dialogs/order-reject-reason-dialog.vue' /* webpackChunkName: "components/dialogs-order-reject-reason-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOrderReprintKotDialog = function DialogsOrderReprintKotDialog() {
  return import('../../components/dialogs/order-reprint-kot-dialog.vue' /* webpackChunkName: "components/dialogs-order-reprint-kot-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsOtpVerificationPasswordChangeDialog = function DialogsOtpVerificationPasswordChangeDialog() {
  return import('../../components/dialogs/otp-verification-password-change-dialog.vue' /* webpackChunkName: "components/dialogs-otp-verification-password-change-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPackagingChargeSlabDialog = function DialogsPackagingChargeSlabDialog() {
  return import('../../components/dialogs/packaging-charge-slab-dialog.vue' /* webpackChunkName: "components/dialogs-packaging-charge-slab-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPairChannelDialog = function DialogsPairChannelDialog() {
  return import('../../components/dialogs/pair-channel-dialog.vue' /* webpackChunkName: "components/dialogs-pair-channel-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPaymentSuccessDialog = function DialogsPaymentSuccessDialog() {
  return import('../../components/dialogs/payment-success-dialog.vue' /* webpackChunkName: "components/dialogs-payment-success-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPhotoCropperDialog = function DialogsPhotoCropperDialog() {
  return import('../../components/dialogs/photo-cropper-dialog.vue' /* webpackChunkName: "components/dialogs-photo-cropper-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPointOfContactDialog = function DialogsPointOfContactDialog() {
  return import('../../components/dialogs/point-of-contact-dialog.vue' /* webpackChunkName: "components/dialogs-point-of-contact-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPriceBreakdownDialog = function DialogsPriceBreakdownDialog() {
  return import('../../components/dialogs/price-breakdown-dialog.vue' /* webpackChunkName: "components/dialogs-price-breakdown-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsPricingRevisionDialog = function DialogsPricingRevisionDialog() {
  return import('../../components/dialogs/pricing-revision-dialog.vue' /* webpackChunkName: "components/dialogs-pricing-revision-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsRateCardDialogue = function DialogsRateCardDialogue() {
  return import('../../components/dialogs/rate-card-dialogue.vue' /* webpackChunkName: "components/dialogs-rate-card-dialogue" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsRemoveModifyCategoryDialog = function DialogsRemoveModifyCategoryDialog() {
  return import('../../components/dialogs/remove-modify-category-dialog.vue' /* webpackChunkName: "components/dialogs-remove-modify-category-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsRemoveModifyItemDialog = function DialogsRemoveModifyItemDialog() {
  return import('../../components/dialogs/remove-modify-item-dialog.vue' /* webpackChunkName: "components/dialogs-remove-modify-item-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsResponsiveDialog = function DialogsResponsiveDialog() {
  return import('../../components/dialogs/responsive-dialog.vue' /* webpackChunkName: "components/dialogs-responsive-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsRestaurantOfflineOrderDialog = function DialogsRestaurantOfflineOrderDialog() {
  return import('../../components/dialogs/restaurant-offline-order-dialog.vue' /* webpackChunkName: "components/dialogs-restaurant-offline-order-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsSetupPrinterDialog = function DialogsSetupPrinterDialog() {
  return import('../../components/dialogs/setup-printer-dialog.vue' /* webpackChunkName: "components/dialogs-setup-printer-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsStoreOfflineConfirmationDialog = function DialogsStoreOfflineConfirmationDialog() {
  return import('../../components/dialogs/store-offline-confirmation-dialog.vue' /* webpackChunkName: "components/dialogs-store-offline-confirmation-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsSubscriptionInactiveDialog = function DialogsSubscriptionInactiveDialog() {
  return import('../../components/dialogs/subscription-inactive-dialog.vue' /* webpackChunkName: "components/dialogs-subscription-inactive-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsSubscriptionPlanDialog = function DialogsSubscriptionPlanDialog() {
  return import('../../components/dialogs/subscription-plan-dialog.vue' /* webpackChunkName: "components/dialogs-subscription-plan-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsWhatsappIntegrationDialog = function DialogsWhatsappIntegrationDialog() {
  return import('../../components/dialogs/whatsapp-integration-dialog.vue' /* webpackChunkName: "components/dialogs-whatsapp-integration-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var DialogsWhatsappReviewDialog = function DialogsWhatsappReviewDialog() {
  return import('../../components/dialogs/whatsapp-review-dialog.vue' /* webpackChunkName: "components/dialogs-whatsapp-review-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesDetailed = function InvoicesDetailed() {
  return import('../../components/invoices/invoices-detailed.vue' /* webpackChunkName: "components/invoices-detailed" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesTableRow = function InvoicesTableRow() {
  return import('../../components/invoices/invoices-table-row.vue' /* webpackChunkName: "components/invoices-table-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesTableView = function InvoicesTableView() {
  return import('../../components/invoices/invoices-table-view.vue' /* webpackChunkName: "components/invoices-table-view" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesTransactionHistoryContent = function InvoicesTransactionHistoryContent() {
  return import('../../components/invoices/invoices-transaction-history-content.vue' /* webpackChunkName: "components/invoices-transaction-history-content" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesTransactionHistoryItem = function InvoicesTransactionHistoryItem() {
  return import('../../components/invoices/invoices-transaction-history-item.vue' /* webpackChunkName: "components/invoices-transaction-history-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesPendingInvoicesStacked = function InvoicesPendingInvoicesStacked() {
  return import('../../components/invoices/pending-invoices-stacked.vue' /* webpackChunkName: "components/invoices-pending-invoices-stacked" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var InvoicesTransactionHistory = function InvoicesTransactionHistory() {
  return import('../../components/invoices/transaction-history.vue' /* webpackChunkName: "components/invoices-transaction-history" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuAddonItemActionTile = function MenuAddonItemActionTile() {
  return import('../../components/menu/addon-item-action-tile.vue' /* webpackChunkName: "components/menu-addon-item-action-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuAddonItemRowWithSwitch = function MenuAddonItemRowWithSwitch() {
  return import('../../components/menu/addon-item-row-with-switch.vue' /* webpackChunkName: "components/menu-addon-item-row-with-switch" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuAddonsList = function MenuAddonsList() {
  return import('../../components/menu/addons-list.vue' /* webpackChunkName: "components/menu-addons-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuAddDropdown = function MenuAddDropdown() {
  return import('../../components/menu/menu-add-dropdown.vue' /* webpackChunkName: "components/menu-add-dropdown" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuAddNewItemDialog = function MenuAddNewItemDialog() {
  return import('../../components/menu/menu-add-new-item-dialog.vue' /* webpackChunkName: "components/menu-add-new-item-dialog" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBulkEditAllCategories = function MenuBulkEditAllCategories() {
  return import('../../components/menu/menu-bulk-edit-all-categories.vue' /* webpackChunkName: "components/menu-bulk-edit-all-categories" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuCategoryOptionTile = function MenuCategoryOptionTile() {
  return import('../../components/menu/menu-category-option-tile.vue' /* webpackChunkName: "components/menu-category-option-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuComboActionTile = function MenuComboActionTile() {
  return import('../../components/menu/menu-combo-action-tile.vue' /* webpackChunkName: "components/menu-combo-action-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuComboItemRowWithSwitch = function MenuComboItemRowWithSwitch() {
  return import('../../components/menu/menu-combo-item-row-with-switch.vue' /* webpackChunkName: "components/menu-combo-item-row-with-switch" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuComboList = function MenuComboList() {
  return import('../../components/menu/menu-combo-list.vue' /* webpackChunkName: "components/menu-combo-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuCreateAddon = function MenuCreateAddon() {
  return import('../../components/menu/menu-create-addon.vue' /* webpackChunkName: "components/menu-create-addon" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuCreateCategory = function MenuCreateCategory() {
  return import('../../components/menu/menu-create-category.vue' /* webpackChunkName: "components/menu-create-category" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuCreateCombo = function MenuCreateCombo() {
  return import('../../components/menu/menu-create-combo.vue' /* webpackChunkName: "components/menu-create-combo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuCreateNewCategoryTile = function MenuCreateNewCategoryTile() {
  return import('../../components/menu/menu-create-new-category-tile.vue' /* webpackChunkName: "components/menu-create-new-category-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuDeleteSubCategory = function MenuDeleteSubCategory() {
  return import('../../components/menu/menu-delete-sub-category.vue' /* webpackChunkName: "components/menu-delete-sub-category" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuDetailHeaderEntryToggler = function MenuDetailHeaderEntryToggler() {
  return import('../../components/menu/menu-detail-header-entry-toggler.vue' /* webpackChunkName: "components/menu-detail-header-entry-toggler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuDetailHeaderRow = function MenuDetailHeaderRow() {
  return import('../../components/menu/menu-detail-header-row.vue' /* webpackChunkName: "components/menu-detail-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuGroupByItemWithOverlay = function MenuGroupByItemWithOverlay() {
  return import('../../components/menu/menu-group-by-item-with-overlay.vue' /* webpackChunkName: "components/menu-group-by-item-with-overlay" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuGroupBy = function MenuGroupBy() {
  return import('../../components/menu/menu-group-by.vue' /* webpackChunkName: "components/menu-group-by" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderAllBrands = function MenuHeaderAllBrands() {
  return import('../../components/menu/menu-header-all-brands.vue' /* webpackChunkName: "components/menu-header-all-brands" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderChargesTile = function MenuHeaderChargesTile() {
  return import('../../components/menu/menu-header-charges-tile.vue' /* webpackChunkName: "components/menu-header-charges-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderMenuFormatter = function MenuHeaderMenuFormatter() {
  return import('../../components/menu/menu-header-menu-formatter.vue' /* webpackChunkName: "components/menu-header-menu-formatter" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderOptionsTile = function MenuHeaderOptionsTile() {
  return import('../../components/menu/menu-header-options-tile.vue' /* webpackChunkName: "components/menu-header-options-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderRow = function MenuHeaderRow() {
  return import('../../components/menu/menu-header-row.vue' /* webpackChunkName: "components/menu-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderSearchField = function MenuHeaderSearchField() {
  return import('../../components/menu/menu-header-search-field.vue' /* webpackChunkName: "components/menu-header-search-field" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuHeaderViewToggler = function MenuHeaderViewToggler() {
  return import('../../components/menu/menu-header-view-toggler.vue' /* webpackChunkName: "components/menu-header-view-toggler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemAddBtn = function MenuItemAddBtn() {
  return import('../../components/menu/menu-item-add-btn.vue' /* webpackChunkName: "components/menu-item-add-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemAddonChoiceGroup = function MenuItemAddonChoiceGroup() {
  return import('../../components/menu/menu-item-addon-choice-group.vue' /* webpackChunkName: "components/menu-item-addon-choice-group" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemForm = function MenuItemForm() {
  return import('../../components/menu/menu-item-form.vue' /* webpackChunkName: "components/menu-item-form" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemModificationRequest = function MenuItemModificationRequest() {
  return import('../../components/menu/menu-item-modification-request.vue' /* webpackChunkName: "components/menu-item-modification-request" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemModificationUpdateBtn = function MenuItemModificationUpdateBtn() {
  return import('../../components/menu/menu-item-modification-update-btn.vue' /* webpackChunkName: "components/menu-item-modification-update-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemRowWithPriceAndSwitch = function MenuItemRowWithPriceAndSwitch() {
  return import('../../components/menu/menu-item-row-with-price-and-switch.vue' /* webpackChunkName: "components/menu-item-row-with-price-and-switch" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemToggleRequest = function MenuItemToggleRequest() {
  return import('../../components/menu/menu-item-toggle-request.vue' /* webpackChunkName: "components/menu-item-toggle-request" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuItemToggleUpdateBtn = function MenuItemToggleUpdateBtn() {
  return import('../../components/menu/menu-item-toggle-update-btn.vue' /* webpackChunkName: "components/menu-item-toggle-update-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuLandingPage = function MenuLandingPage() {
  return import('../../components/menu/menu-landing-page.vue' /* webpackChunkName: "components/menu-landing-page" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuMoveToSubcategory = function MenuMoveToSubcategory() {
  return import('../../components/menu/menu-move-to-subcategory.vue' /* webpackChunkName: "components/menu-move-to-subcategory" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNoData = function MenuNoData() {
  return import('../../components/menu/menu-no-data.vue' /* webpackChunkName: "components/menu-no-data" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNormalItemActionTile = function MenuNormalItemActionTile() {
  return import('../../components/menu/menu-normal-item-action-tile.vue' /* webpackChunkName: "components/menu-normal-item-action-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNormalItemSection = function MenuNormalItemSection() {
  return import('../../components/menu/menu-normal-item-section.vue' /* webpackChunkName: "components/menu-normal-item-section" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNormalListBatchHeader = function MenuNormalListBatchHeader() {
  return import('../../components/menu/menu-normal-list-batch-header.vue' /* webpackChunkName: "components/menu-normal-list-batch-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNormalList = function MenuNormalList() {
  return import('../../components/menu/menu-normal-list.vue' /* webpackChunkName: "components/menu-normal-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuNormalView = function MenuNormalView() {
  return import('../../components/menu/menu-normal-view.vue' /* webpackChunkName: "components/menu-normal-view" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOverlappingBrandAvatars = function MenuOverlappingBrandAvatars() {
  return import('../../components/menu/menu-overlapping-brand-avatars.vue' /* webpackChunkName: "components/menu-overlapping-brand-avatars" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuPendingCatalogueSyncList = function MenuPendingCatalogueSyncList() {
  return import('../../components/menu/menu-pending-catalogue-sync-list.vue' /* webpackChunkName: "components/menu-pending-catalogue-sync-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuPhotoUploader = function MenuPhotoUploader() {
  return import('../../components/menu/menu-photo-uploader.vue' /* webpackChunkName: "components/menu-photo-uploader" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuSetKotGroup = function MenuSetKotGroup() {
  return import('../../components/menu/menu-set-kot-group.vue' /* webpackChunkName: "components/menu-set-kot-group" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuShare = function MenuShare() {
  return import('../../components/menu/menu-share.vue' /* webpackChunkName: "components/menu-share" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuSoldOutList = function MenuSoldOutList() {
  return import('../../components/menu/menu-sold-out-list.vue' /* webpackChunkName: "components/menu-sold-out-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUpdateMenuBtn = function MenuUpdateMenuBtn() {
  return import('../../components/menu/menu-update-menu-btn.vue' /* webpackChunkName: "components/menu-update-menu-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadAddonsBulkUpload = function MenuUploadAddonsBulkUpload() {
  return import('../../components/menu/menu-upload-addons-bulk-upload.vue' /* webpackChunkName: "components/menu-upload-addons-bulk-upload" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadAddonsEmpty = function MenuUploadAddonsEmpty() {
  return import('../../components/menu/menu-upload-addons-empty.vue' /* webpackChunkName: "components/menu-upload-addons-empty" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadBulkUploadScreen = function MenuUploadBulkUploadScreen() {
  return import('../../components/menu/menu-upload-bulk-upload-screen.vue' /* webpackChunkName: "components/menu-upload-bulk-upload-screen" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadCarouselCard = function MenuUploadCarouselCard() {
  return import('../../components/menu/menu-upload-carousel-card.vue' /* webpackChunkName: "components/menu-upload-carousel-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadCarousel = function MenuUploadCarousel() {
  return import('../../components/menu/menu-upload-carousel.vue' /* webpackChunkName: "components/menu-upload-carousel" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadCategoryOptionTile = function MenuUploadCategoryOptionTile() {
  return import('../../components/menu/menu-upload-category-option-tile.vue' /* webpackChunkName: "components/menu-upload-category-option-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadCategory = function MenuUploadCategory() {
  return import('../../components/menu/menu-upload-category.vue' /* webpackChunkName: "components/menu-upload-category" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadConfigureChargesItem = function MenuUploadConfigureChargesItem() {
  return import('../../components/menu/menu-upload-configure-charges-item.vue' /* webpackChunkName: "components/menu-upload-configure-charges-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadConfigureCharges = function MenuUploadConfigureCharges() {
  return import('../../components/menu/menu-upload-configure-charges.vue' /* webpackChunkName: "components/menu-upload-configure-charges" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadDraggableItem = function MenuUploadDraggableItem() {
  return import('../../components/menu/menu-upload-draggable-item.vue' /* webpackChunkName: "components/menu-upload-draggable-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadEmptyFilteredItemsTile = function MenuUploadEmptyFilteredItemsTile() {
  return import('../../components/menu/menu-upload-empty-filtered-items-tile.vue' /* webpackChunkName: "components/menu-upload-empty-filtered-items-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadFileSelector = function MenuUploadFileSelector() {
  return import('../../components/menu/menu-upload-file-selector.vue' /* webpackChunkName: "components/menu-upload-file-selector" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridFilters = function MenuUploadGridFilters() {
  return import('../../components/menu/menu-upload-grid-filters.vue' /* webpackChunkName: "components/menu-upload-grid-filters" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemAddPhoto = function MenuUploadGridItemAddPhoto() {
  return import('../../components/menu/menu-upload-grid-item-add-photo.vue' /* webpackChunkName: "components/menu-upload-grid-item-add-photo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemAddonGroup = function MenuUploadGridItemAddonGroup() {
  return import('../../components/menu/menu-upload-grid-item-addon-group.vue' /* webpackChunkName: "components/menu-upload-grid-item-addon-group" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemAvatarName = function MenuUploadGridItemAvatarName() {
  return import('../../components/menu/menu-upload-grid-item-avatar-name.vue' /* webpackChunkName: "components/menu-upload-grid-item-avatar-name" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemDescription = function MenuUploadGridItemDescription() {
  return import('../../components/menu/menu-upload-grid-item-description.vue' /* webpackChunkName: "components/menu-upload-grid-item-description" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemSetAddons = function MenuUploadGridItemSetAddons() {
  return import('../../components/menu/menu-upload-grid-item-set-addons.vue' /* webpackChunkName: "components/menu-upload-grid-item-set-addons" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItemSetChoices = function MenuUploadGridItemSetChoices() {
  return import('../../components/menu/menu-upload-grid-item-set-choices.vue' /* webpackChunkName: "components/menu-upload-grid-item-set-choices" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGridItem = function MenuUploadGridItem() {
  return import('../../components/menu/menu-upload-grid-item.vue' /* webpackChunkName: "components/menu-upload-grid-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadGrid = function MenuUploadGrid() {
  return import('../../components/menu/menu-upload-grid.vue' /* webpackChunkName: "components/menu-upload-grid" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadHeader = function MenuUploadHeader() {
  return import('../../components/menu/menu-upload-header.vue' /* webpackChunkName: "components/menu-upload-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadImageBulkUpload = function MenuUploadImageBulkUpload() {
  return import('../../components/menu/menu-upload-image-bulk-upload.vue' /* webpackChunkName: "components/menu-upload-image-bulk-upload" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadImageThumbnail = function MenuUploadImageThumbnail() {
  return import('../../components/menu/menu-upload-image-thumbnail.vue' /* webpackChunkName: "components/menu-upload-image-thumbnail" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadKot = function MenuUploadKot() {
  return import('../../components/menu/menu-upload-kot.vue' /* webpackChunkName: "components/menu-upload-kot" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadMappingStep = function MenuUploadMappingStep() {
  return import('../../components/menu/menu-upload-mapping-step.vue' /* webpackChunkName: "components/menu-upload-mapping-step" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadMoveToCategoryPopup = function MenuUploadMoveToCategoryPopup() {
  return import('../../components/menu/menu-upload-move-to-category-popup.vue' /* webpackChunkName: "components/menu-upload-move-to-category-popup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadProgressHeader = function MenuUploadProgressHeader() {
  return import('../../components/menu/menu-upload-progress-header.vue' /* webpackChunkName: "components/menu-upload-progress-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadSettingUpScreen = function MenuUploadSettingUpScreen() {
  return import('../../components/menu/menu-upload-setting-up-screen.vue' /* webpackChunkName: "components/menu-upload-setting-up-screen" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadSteppers = function MenuUploadSteppers() {
  return import('../../components/menu/menu-upload-steppers.vue' /* webpackChunkName: "components/menu-upload-steppers" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadUnassignedItemCard = function MenuUploadUnassignedItemCard() {
  return import('../../components/menu/menu-upload-unassigned-item-card.vue' /* webpackChunkName: "components/menu-upload-unassigned-item-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuUploadVerifyItems = function MenuUploadVerifyItems() {
  return import('../../components/menu/menu-upload-verify-items.vue' /* webpackChunkName: "components/menu-upload-verify-items" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuMultiSelectionGrid = function MenuMultiSelectionGrid() {
  return import('../../components/menu/multi-selection-grid.vue' /* webpackChunkName: "components/menu-multi-selection-grid" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuRemoveModifyItemTile = function MenuRemoveModifyItemTile() {
  return import('../../components/menu/remove-modify-item-tile.vue' /* webpackChunkName: "components/menu-remove-modify-item-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBookDeliveryLocationCard = function MenuBookDeliveryLocationCard() {
  return import('../../components/menu-book/menu-book-delivery-location-card.vue' /* webpackChunkName: "components/menu-book-delivery-location-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBookHeader = function MenuBookHeader() {
  return import('../../components/menu-book/menu-book-header.vue' /* webpackChunkName: "components/menu-book-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBookMenuItemTile = function MenuBookMenuItemTile() {
  return import('../../components/menu-book/menu-book-menu-item-tile.vue' /* webpackChunkName: "components/menu-book-menu-item-tile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBookMenuItem = function MenuBookMenuItem() {
  return import('../../components/menu-book/menu-book-menu-item.vue' /* webpackChunkName: "components/menu-book-menu-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBookMenuList = function MenuBookMenuList() {
  return import('../../components/menu-book/menu-book-menu-list.vue' /* webpackChunkName: "components/menu-book-menu-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuBook = function MenuBook() {
  return import('../../components/menu-book/menu-book.vue' /* webpackChunkName: "components/menu-book" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOrderItemAddedCard = function MenuOrderItemAddedCard() {
  return import('../../components/menu-order/item-added-card.vue' /* webpackChunkName: "components/menu-order-item-added-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOrderItemTextDraft = function MenuOrderItemTextDraft() {
  return import('../../components/menu-order/menu-order-item-text-draft.vue' /* webpackChunkName: "components/menu-order-item-text-draft" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOrderMenuItem = function MenuOrderMenuItem() {
  return import('../../components/menu-order/menu-order-menu-item.vue' /* webpackChunkName: "components/menu-order-menu-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOrderMenuList = function MenuOrderMenuList() {
  return import('../../components/menu-order/menu-order-menu-list.vue' /* webpackChunkName: "components/menu-order-menu-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuOrder = function MenuOrder() {
  return import('../../components/menu-order/menu-order.vue' /* webpackChunkName: "components/menu-order" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var MenuShareFeedback = function MenuShareFeedback() {
  return import('../../components/menu-order/menu-share-feedback.vue' /* webpackChunkName: "components/menu-share-feedback" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var OrderStatusProgress = function OrderStatusProgress() {
  return import('../../components/order-status/order-status-progress.vue' /* webpackChunkName: "components/order-status-progress" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var OrderStatus = function OrderStatus() {
  return import('../../components/order-status/order-status.vue' /* webpackChunkName: "components/order-status" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplateBillPrint = function PrintTemplateBillPrint() {
  return import('../../components/print-template/print-template-bill-print.vue' /* webpackChunkName: "components/print-template-bill-print" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplateItemWiseReport = function PrintTemplateItemWiseReport() {
  return import('../../components/print-template/print-template-item-wise-report.vue' /* webpackChunkName: "components/print-template-item-wise-report" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplateKot = function PrintTemplateKot() {
  return import('../../components/print-template/print-template-kot.vue' /* webpackChunkName: "components/print-template-kot" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplateLayout = function PrintTemplateLayout() {
  return import('../../components/print-template/print-template-layout.vue' /* webpackChunkName: "components/print-template-layout" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplateTestPrint = function PrintTemplateTestPrint() {
  return import('../../components/print-template/print-template-test-print.vue' /* webpackChunkName: "components/print-template-test-print" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverBrandAssosciatedChannels = function RecieverBrandAssosciatedChannels() {
  return import('../../components/reciever/brand-assosciated-channels.vue' /* webpackChunkName: "components/reciever-brand-assosciated-channels" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverBrandOnlineStatusHandler = function RecieverBrandOnlineStatusHandler() {
  return import('../../components/reciever/brand-online-status-handler.vue' /* webpackChunkName: "components/reciever-brand-online-status-handler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverChannelOnlineStatusHandler = function RecieverChannelOnlineStatusHandler() {
  return import('../../components/reciever/channel-online-status-handler.vue' /* webpackChunkName: "components/reciever-channel-online-status-handler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverCloudKitchen = function RecieverCloudKitchen() {
  return import('../../components/reciever/cloud-kitchen.vue' /* webpackChunkName: "components/reciever-cloud-kitchen" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverCompleteTheSetup = function RecieverCompleteTheSetup() {
  return import('../../components/reciever/complete-the-setup.vue' /* webpackChunkName: "components/reciever-complete-the-setup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperApproveBsp = function RecieverIntegrationStepperApproveBsp() {
  return import('../../components/reciever/integration-stepper-approve-bsp.vue' /* webpackChunkName: "components/reciever-integration-stepper-approve-bsp" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperCreateFacebookCatalogue = function RecieverIntegrationStepperCreateFacebookCatalogue() {
  return import('../../components/reciever/integration-stepper-create-facebook-catalogue.vue' /* webpackChunkName: "components/reciever-integration-stepper-create-facebook-catalogue" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperDeliveryRadiusAndCharges = function RecieverIntegrationStepperDeliveryRadiusAndCharges() {
  return import('../../components/reciever/integration-stepper-delivery-radius-and-charges.vue' /* webpackChunkName: "components/reciever-integration-stepper-delivery-radius-and-charges" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperReviewWhatsappMenu = function RecieverIntegrationStepperReviewWhatsappMenu() {
  return import('../../components/reciever/integration-stepper-review-whatsapp-menu.vue' /* webpackChunkName: "components/reciever-integration-stepper-review-whatsapp-menu" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperSetupMiddleware = function RecieverIntegrationStepperSetupMiddleware() {
  return import('../../components/reciever/integration-stepper-setup-middleware.vue' /* webpackChunkName: "components/reciever-integration-stepper-setup-middleware" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperUploadMenu = function RecieverIntegrationStepperUploadMenu() {
  return import('../../components/reciever/integration-stepper-upload-menu.vue' /* webpackChunkName: "components/reciever-integration-stepper-upload-menu" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperVerifyMobileForWhatsappIntegration = function RecieverIntegrationStepperVerifyMobileForWhatsappIntegration() {
  return import('../../components/reciever/integration-stepper-verify-mobile-for-whatsapp-integration.vue' /* webpackChunkName: "components/reciever-integration-stepper-verify-mobile-for-whatsapp-integration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationStepperWizard = function RecieverIntegrationStepperWizard() {
  return import('../../components/reciever/integration-stepper-wizard.vue' /* webpackChunkName: "components/reciever-integration-stepper-wizard" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverIntegrationUnderProcessing = function RecieverIntegrationUnderProcessing() {
  return import('../../components/reciever/integration-under-processing.vue' /* webpackChunkName: "components/reciever-integration-under-processing" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverLocationOnlineStatusHandler = function RecieverLocationOnlineStatusHandler() {
  return import('../../components/reciever/location-online-status-handler.vue' /* webpackChunkName: "components/reciever-location-online-status-handler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOnHoldItemsList = function RecieverOnHoldItemsList() {
  return import('../../components/reciever/on-hold-items-list.vue' /* webpackChunkName: "components/reciever-on-hold-items-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderActionBtn = function RecieverOrderActionBtn() {
  return import('../../components/reciever/order-action-btn.vue' /* webpackChunkName: "components/reciever-order-action-btn" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderAlertCancelledOrder = function RecieverOrderAlertCancelledOrder() {
  return import('../../components/reciever/order-alert-cancelled-order.vue' /* webpackChunkName: "components/reciever-order-alert-cancelled-order" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderAlertNewOrder = function RecieverOrderAlertNewOrder() {
  return import('../../components/reciever/order-alert-new-order.vue' /* webpackChunkName: "components/reciever-order-alert-new-order" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderAlert = function RecieverOrderAlert() {
  return import('../../components/reciever/order-alert.vue' /* webpackChunkName: "components/reciever-order-alert" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderBarcode = function RecieverOrderBarcode() {
  return import('../../components/reciever/order-barcode.vue' /* webpackChunkName: "components/reciever-order-barcode" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsActionRow = function RecieverOrderDetailsActionRow() {
  return import('../../components/reciever/order-details-action-row.vue' /* webpackChunkName: "components/reciever-order-details-action-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsAppBar = function RecieverOrderDetailsAppBar() {
  return import('../../components/reciever/order-details-app-bar.vue' /* webpackChunkName: "components/reciever-order-details-app-bar" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsBillAmountRow = function RecieverOrderDetailsBillAmountRow() {
  return import('../../components/reciever/order-details-bill-amount-row.vue' /* webpackChunkName: "components/reciever-order-details-bill-amount-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsCardMobile = function RecieverOrderDetailsCardMobile() {
  return import('../../components/reciever/order-details-card-mobile.vue' /* webpackChunkName: "components/reciever-order-details-card-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsDeliveryDetails = function RecieverOrderDetailsDeliveryDetails() {
  return import('../../components/reciever/order-details-delivery-details.vue' /* webpackChunkName: "components/reciever-order-details-delivery-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsItemDetailsRowNameSpan = function RecieverOrderDetailsItemDetailsRowNameSpan() {
  return import('../../components/reciever/order-details-item-details-row-name-span.vue' /* webpackChunkName: "components/reciever-order-details-item-details-row-name-span" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsItemDetailsRow = function RecieverOrderDetailsItemDetailsRow() {
  return import('../../components/reciever/order-details-item-details-row.vue' /* webpackChunkName: "components/reciever-order-details-item-details-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsItemDetails = function RecieverOrderDetailsItemDetails() {
  return import('../../components/reciever/order-details-item-details.vue' /* webpackChunkName: "components/reciever-order-details-item-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsOrderDuration = function RecieverOrderDetailsOrderDuration() {
  return import('../../components/reciever/order-details-order-duration.vue' /* webpackChunkName: "components/reciever-order-details-order-duration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsOrderStatusStepper = function RecieverOrderDetailsOrderStatusStepper() {
  return import('../../components/reciever/order-details-order-status-stepper.vue' /* webpackChunkName: "components/reciever-order-details-order-status-stepper" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsPriceBreakup = function RecieverOrderDetailsPriceBreakup() {
  return import('../../components/reciever/order-details-price-breakup.vue' /* webpackChunkName: "components/reciever-order-details-price-breakup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsRiderDetails = function RecieverOrderDetailsRiderDetails() {
  return import('../../components/reciever/order-details-rider-details.vue' /* webpackChunkName: "components/reciever-order-details-rider-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsSimple = function RecieverOrderDetailsSimple() {
  return import('../../components/reciever/order-details-simple.vue' /* webpackChunkName: "components/reciever-order-details-simple" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetailsWaitingForNewRider = function RecieverOrderDetailsWaitingForNewRider() {
  return import('../../components/reciever/order-details-waiting-for-new-rider.vue' /* webpackChunkName: "components/reciever-order-details-waiting-for-new-rider" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDetails = function RecieverOrderDetails() {
  return import('../../components/reciever/order-details.vue' /* webpackChunkName: "components/reciever-order-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderDurationProgress = function RecieverOrderDurationProgress() {
  return import('../../components/reciever/order-duration-progress.vue' /* webpackChunkName: "components/reciever-order-duration-progress" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderGridCol = function RecieverOrderGridCol() {
  return import('../../components/reciever/order-grid-col.vue' /* webpackChunkName: "components/reciever-order-grid-col" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderGrid = function RecieverOrderGrid() {
  return import('../../components/reciever/order-grid.vue' /* webpackChunkName: "components/reciever-order-grid" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderItemsList = function RecieverOrderItemsList() {
  return import('../../components/reciever/order-items-list.vue' /* webpackChunkName: "components/reciever-order-items-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderListHeader = function RecieverOrderListHeader() {
  return import('../../components/reciever/order-list-header.vue' /* webpackChunkName: "components/reciever-order-list-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderListRow = function RecieverOrderListRow() {
  return import('../../components/reciever/order-list-row.vue' /* webpackChunkName: "components/reciever-order-list-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderList = function RecieverOrderList() {
  return import('../../components/reciever/order-list.vue' /* webpackChunkName: "components/reciever-order-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderOtpChipMobile = function RecieverOrderOtpChipMobile() {
  return import('../../components/reciever/order-otp-chip-mobile.vue' /* webpackChunkName: "components/reciever-order-otp-chip-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverOrderRiderDetails = function RecieverOrderRiderDetails() {
  return import('../../components/reciever/order-rider-details.vue' /* webpackChunkName: "components/reciever-order-rider-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverReceiverChannelMobileCard = function RecieverReceiverChannelMobileCard() {
  return import('../../components/reciever/receiver-channel-mobile-card.vue' /* webpackChunkName: "components/reciever-receiver-channel-mobile-card" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverChannelMobile = function RecieverChannelMobile() {
  return import('../../components/reciever/reciever-channel-mobile.vue' /* webpackChunkName: "components/reciever-channel-mobile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverChannelsRowCol = function RecieverChannelsRowCol() {
  return import('../../components/reciever/reciever-channels-row-col.vue' /* webpackChunkName: "components/reciever-channels-row-col" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverChannelsRow = function RecieverChannelsRow() {
  return import('../../components/reciever/reciever-channels-row.vue' /* webpackChunkName: "components/reciever-channels-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverSearchField = function RecieverSearchField() {
  return import('../../components/reciever/reciever-search-field.vue' /* webpackChunkName: "components/reciever-search-field" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverSocket = function RecieverSocket() {
  return import('../../components/reciever/reciever-socket.vue' /* webpackChunkName: "components/reciever-socket" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var Reciever = function Reciever() {
  return import('../../components/reciever/reciever.vue' /* webpackChunkName: "components/reciever" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverWhatsappIntegrationManagerIdInput = function RecieverWhatsappIntegrationManagerIdInput() {
  return import('../../components/reciever/whatsapp-integration-manager-id-input.vue' /* webpackChunkName: "components/reciever-whatsapp-integration-manager-id-input" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RecieverWhatsappIntegrationUploadRestaurantDetails = function RecieverWhatsappIntegrationUploadRestaurantDetails() {
  return import('../../components/reciever/whatsapp-integration-upload-restaurant-details.vue' /* webpackChunkName: "components/reciever-whatsapp-integration-upload-restaurant-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportBusinessGraph = function ReportBusinessGraph() {
  return import('../../components/report/report-business-graph.vue' /* webpackChunkName: "components/report-business-graph" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportBusinessInsights = function ReportBusinessInsights() {
  return import('../../components/report/report-business-insights.vue' /* webpackChunkName: "components/report-business-insights" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportBusinessOverall = function ReportBusinessOverall() {
  return import('../../components/report/report-business-overall.vue' /* webpackChunkName: "components/report-business-overall" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportCanellationReasons = function ReportCanellationReasons() {
  return import('../../components/report/report-canellation-reasons.vue' /* webpackChunkName: "components/report-canellation-reasons" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportChannelComparison = function ReportChannelComparison() {
  return import('../../components/report/report-channel-comparison.vue' /* webpackChunkName: "components/report-channel-comparison" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportChannelOrderTable = function ReportChannelOrderTable() {
  return import('../../components/report/report-channel-order-table.vue' /* webpackChunkName: "components/report-channel-order-table" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportDeliveredLocation = function ReportDeliveredLocation() {
  return import('../../components/report/report-delivered-location.vue' /* webpackChunkName: "components/report-delivered-location" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportDownloadOptions = function ReportDownloadOptions() {
  return import('../../components/report/report-download-options.vue' /* webpackChunkName: "components/report-download-options" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportDownload = function ReportDownload() {
  return import('../../components/report/report-download.vue' /* webpackChunkName: "components/report-download" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportHeaderChannelSelector = function ReportHeaderChannelSelector() {
  return import('../../components/report/report-header-channel-selector.vue' /* webpackChunkName: "components/report-header-channel-selector" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportHeaderDateRangeOptions = function ReportHeaderDateRangeOptions() {
  return import('../../components/report/report-header-date-range-options.vue' /* webpackChunkName: "components/report-header-date-range-options" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportHeaderDateRangeSelector = function ReportHeaderDateRangeSelector() {
  return import('../../components/report/report-header-date-range-selector.vue' /* webpackChunkName: "components/report-header-date-range-selector" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportHeaderOutletSelector = function ReportHeaderOutletSelector() {
  return import('../../components/report/report-header-outlet-selector.vue' /* webpackChunkName: "components/report-header-outlet-selector" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportHeaderRow = function ReportHeaderRow() {
  return import('../../components/report/report-header-row.vue' /* webpackChunkName: "components/report-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemSales = function ReportItemSales() {
  return import('../../components/report/report-item-sales.vue' /* webpackChunkName: "components/report-item-sales" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseComparison = function ReportItemWiseComparison() {
  return import('../../components/report/report-item-wise-comparison.vue' /* webpackChunkName: "components/report-item-wise-comparison" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseFrequentlyBought = function ReportItemWiseFrequentlyBought() {
  return import('../../components/report/report-item-wise-frequently-bought.vue' /* webpackChunkName: "components/report-item-wise-frequently-bought" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWisePeakHours = function ReportItemWisePeakHours() {
  return import('../../components/report/report-item-wise-peak-hours.vue' /* webpackChunkName: "components/report-item-wise-peak-hours" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseSalesDetails = function ReportItemWiseSalesDetails() {
  return import('../../components/report/report-item-wise-sales-details.vue' /* webpackChunkName: "components/report-item-wise-sales-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseSalesDisplayCategorySwitch = function ReportItemWiseSalesDisplayCategorySwitch() {
  return import('../../components/report/report-item-wise-sales-display-category-switch.vue' /* webpackChunkName: "components/report-item-wise-sales-display-category-switch" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseSalesTableCategoryHeader = function ReportItemWiseSalesTableCategoryHeader() {
  return import('../../components/report/report-item-wise-sales-table-category-header.vue' /* webpackChunkName: "components/report-item-wise-sales-table-category-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseSalesTableHeader = function ReportItemWiseSalesTableHeader() {
  return import('../../components/report/report-item-wise-sales-table-header.vue' /* webpackChunkName: "components/report-item-wise-sales-table-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportItemWiseSalesTable = function ReportItemWiseSalesTable() {
  return import('../../components/report/report-item-wise-sales-table.vue' /* webpackChunkName: "components/report-item-wise-sales-table" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderAcknowledgementStagesDurationTabs = function ReportOrderAcknowledgementStagesDurationTabs() {
  return import('../../components/report/report-order-acknowledgement-stages-duration-tabs.vue' /* webpackChunkName: "components/report-order-acknowledgement-stages-duration-tabs" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderDetailsList = function ReportOrderDetailsList() {
  return import('../../components/report/report-order-details-list.vue' /* webpackChunkName: "components/report-order-details-list" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderDuration = function ReportOrderDuration() {
  return import('../../components/report/report-order-duration.vue' /* webpackChunkName: "components/report-order-duration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderFilterOptions = function ReportOrderFilterOptions() {
  return import('../../components/report/report-order-filter-options.vue' /* webpackChunkName: "components/report-order-filter-options" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderFilter = function ReportOrderFilter() {
  return import('../../components/report/report-order-filter.vue' /* webpackChunkName: "components/report-order-filter" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderStages = function ReportOrderStages() {
  return import('../../components/report/report-order-stages.vue' /* webpackChunkName: "components/report-order-stages" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrderTable = function ReportOrderTable() {
  return import('../../components/report/report-order-table.vue' /* webpackChunkName: "components/report-order-table" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrdersCount = function ReportOrdersCount() {
  return import('../../components/report/report-orders-count.vue' /* webpackChunkName: "components/report-orders-count" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrdersSearch = function ReportOrdersSearch() {
  return import('../../components/report/report-orders-search.vue' /* webpackChunkName: "components/report-orders-search" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrdersTableHeader = function ReportOrdersTableHeader() {
  return import('../../components/report/report-orders-table-header.vue' /* webpackChunkName: "components/report-orders-table-header" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrdersTableRow = function ReportOrdersTableRow() {
  return import('../../components/report/report-orders-table-row.vue' /* webpackChunkName: "components/report-orders-table-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportOrdersTable = function ReportOrdersTable() {
  return import('../../components/report/report-orders-table.vue' /* webpackChunkName: "components/report-orders-table" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportPeakHours = function ReportPeakHours() {
  return import('../../components/report/report-peak-hours.vue' /* webpackChunkName: "components/report-peak-hours" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportPrintOptions = function ReportPrintOptions() {
  return import('../../components/report/report-print-options.vue' /* webpackChunkName: "components/report-print-options" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportPrintTitleReportName = function ReportPrintTitleReportName() {
  return import('../../components/report/report-print-title-report-name.vue' /* webpackChunkName: "components/report-print-title-report-name" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportPrintTitle = function ReportPrintTitle() {
  return import('../../components/report/report-print-title.vue' /* webpackChunkName: "components/report-print-title" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportPrint = function ReportPrint() {
  return import('../../components/report/report-print.vue' /* webpackChunkName: "components/report-print" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportSalesSummary = function ReportSalesSummary() {
  return import('../../components/report/report-sales-summary.vue' /* webpackChunkName: "components/report-sales-summary" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportStoreAvailability = function ReportStoreAvailability() {
  return import('../../components/report/report-store-availability.vue' /* webpackChunkName: "components/report-store-availability" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var ReportView = function ReportView() {
  return import('../../components/report/report-view.vue' /* webpackChunkName: "components/report-view" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantAddChannels = function RestaurantAddChannels() {
  return import('../../components/restaurant/add-channels.vue' /* webpackChunkName: "components/restaurant-add-channels" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantConfigureChannels = function RestaurantConfigureChannels() {
  return import('../../components/restaurant/configure-channels.vue' /* webpackChunkName: "components/restaurant-configure-channels" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantCreateRestaurantForm = function RestaurantCreateRestaurantForm() {
  return import('../../components/restaurant/create-restaurant-form.vue' /* webpackChunkName: "components/restaurant-create-restaurant-form" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantProfile = function RestaurantProfile() {
  return import('../../components/restaurant/restaurant-profile.vue' /* webpackChunkName: "components/restaurant-profile" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantSignupBusinessTypeConfiguration = function RestaurantSignupBusinessTypeConfiguration() {
  return import('../../components/restaurant/signup-business-type-configuration.vue' /* webpackChunkName: "components/restaurant-signup-business-type-configuration" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantSignupCreateBusinessAccount = function RestaurantSignupCreateBusinessAccount() {
  return import('../../components/restaurant/signup-create-business-account.vue' /* webpackChunkName: "components/restaurant-signup-create-business-account" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantSignupParentCompanyDetails = function RestaurantSignupParentCompanyDetails() {
  return import('../../components/restaurant/signup-parent-company-details.vue' /* webpackChunkName: "components/restaurant-signup-parent-company-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantSignupRestaurantProfileSetup = function RestaurantSignupRestaurantProfileSetup() {
  return import('../../components/restaurant/signup-restaurant-profile-setup.vue' /* webpackChunkName: "components/restaurant-signup-restaurant-profile-setup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var RestaurantSignupRestaurantProfileSetupItem = function RestaurantSignupRestaurantProfileSetupItem() {
  return import('../../components/restaurant/signup-restaurant-profile-setup__item.vue' /* webpackChunkName: "components/restaurant-signup-restaurant-profile-setup-item" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsChannelManagerFormBrandChannelRow = function SettingsChannelManagerFormBrandChannelRow() {
  return import('../../components/settings/channel-manager-form-brand-channel-row.vue' /* webpackChunkName: "components/settings-channel-manager-form-brand-channel-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsChannelManagerFormBrandSection = function SettingsChannelManagerFormBrandSection() {
  return import('../../components/settings/channel-manager-form-brand-section.vue' /* webpackChunkName: "components/settings-channel-manager-form-brand-section" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsChannelManagerForm = function SettingsChannelManagerForm() {
  return import('../../components/settings/channel-manager-form.vue' /* webpackChunkName: "components/settings-channel-manager-form" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsChannelManager = function SettingsChannelManager() {
  return import('../../components/settings/channel-manager.vue' /* webpackChunkName: "components/settings-channel-manager" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsGeneralSettings = function SettingsGeneralSettings() {
  return import('../../components/settings/general-settings.vue' /* webpackChunkName: "components/settings-general-settings" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsPrinterSettingsPrintWidth = function SettingsPrinterSettingsPrintWidth() {
  return import('../../components/settings/printer-settings-print-width.vue' /* webpackChunkName: "components/settings-printer-settings-print-width" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsAvailableUsers = function SettingsAvailableUsers() {
  return import('../../components/settings/settings-available-users.vue' /* webpackChunkName: "components/settings-available-users" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsBillingPlan = function SettingsBillingPlan() {
  return import('../../components/settings/settings-billing-plan.vue' /* webpackChunkName: "components/settings-billing-plan" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsHeaderRow = function SettingsHeaderRow() {
  return import('../../components/settings/settings-header-row.vue' /* webpackChunkName: "components/settings-header-row" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsHeaderSearchField = function SettingsHeaderSearchField() {
  return import('../../components/settings/settings-header-search-field.vue' /* webpackChunkName: "components/settings-header-search-field" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsHeaderViewToggler = function SettingsHeaderViewToggler() {
  return import('../../components/settings/settings-header-view-toggler.vue' /* webpackChunkName: "components/settings-header-view-toggler" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsKotPrinter = function SettingsKotPrinter() {
  return import('../../components/settings/settings-kot-printer.vue' /* webpackChunkName: "components/settings-kot-printer" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsMobileBody = function SettingsMobileBody() {
  return import('../../components/settings/settings-mobile-body.vue' /* webpackChunkName: "components/settings-mobile-body" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRemoveOutlet = function SettingsRemoveOutlet() {
  return import('../../components/settings/settings-remove-outlet.vue' /* webpackChunkName: "components/settings-remove-outlet" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantBasicDetails = function SettingsRestaurantBasicDetails() {
  return import('../../components/settings/settings-restaurant-basic-details.vue' /* webpackChunkName: "components/settings-restaurant-basic-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantPrintBill = function SettingsRestaurantPrintBill() {
  return import('../../components/settings/settings-restaurant-print-bill.vue' /* webpackChunkName: "components/settings-restaurant-print-bill" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantPrinter = function SettingsRestaurantPrinter() {
  return import('../../components/settings/settings-restaurant-printer.vue' /* webpackChunkName: "components/settings-restaurant-printer" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantStoreAvailability = function SettingsRestaurantStoreAvailability() {
  return import('../../components/settings/settings-restaurant-store-availability.vue' /* webpackChunkName: "components/settings-restaurant-store-availability" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantTaxation = function SettingsRestaurantTaxation() {
  return import('../../components/settings/settings-restaurant-taxation.vue' /* webpackChunkName: "components/settings-restaurant-taxation" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurantUpdateLogo = function SettingsRestaurantUpdateLogo() {
  return import('../../components/settings/settings-restaurant-update-logo.vue' /* webpackChunkName: "components/settings-restaurant-update-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsRestaurant = function SettingsRestaurant() {
  return import('../../components/settings/settings-restaurant.vue' /* webpackChunkName: "components/settings-restaurant" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsUserSettingsBasicDetails = function SettingsUserSettingsBasicDetails() {
  return import('../../components/settings/user-settings-basic-details.vue' /* webpackChunkName: "components/settings-user-settings-basic-details" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsUserSettingsProfilePicture = function SettingsUserSettingsProfilePicture() {
  return import('../../components/settings/user-settings-profile-picture.vue' /* webpackChunkName: "components/settings-user-settings-profile-picture" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsUserSettingsResetPassword = function SettingsUserSettingsResetPassword() {
  return import('../../components/settings/user-settings-reset-password.vue' /* webpackChunkName: "components/settings-user-settings-reset-password" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SettingsUserSettings = function SettingsUserSettings() {
  return import('../../components/settings/user-settings.vue' /* webpackChunkName: "components/settings-user-settings" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var SplashScreen = function SplashScreen() {
  return import('../../components/splash-screen/splash-screen.vue' /* webpackChunkName: "components/splash-screen" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserSignupOtp = function UserSignupOtp() {
  return import('../../components/user/signup-otp.vue' /* webpackChunkName: "components/user-signup-otp" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserForgotPasswordGetPhoneMail = function UserForgotPasswordGetPhoneMail() {
  return import('../../components/user/user-forgot-password-get-phone-mail.vue' /* webpackChunkName: "components/user-forgot-password-get-phone-mail" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserForgotPasswordOtp = function UserForgotPasswordOtp() {
  return import('../../components/user/user-forgot-password-otp.vue' /* webpackChunkName: "components/user-forgot-password-otp" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserForgotPasswordReset = function UserForgotPasswordReset() {
  return import('../../components/user/user-forgot-password-reset.vue' /* webpackChunkName: "components/user-forgot-password-reset" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserLogin = function UserLogin() {
  return import('../../components/user/user-login.vue' /* webpackChunkName: "components/user-login" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserLogout = function UserLogout() {
  return import('../../components/user/user-logout.vue' /* webpackChunkName: "components/user-logout" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserProfileAvatar = function UserProfileAvatar() {
  return import('../../components/user/user-profile-avatar.vue' /* webpackChunkName: "components/user-profile-avatar" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var UserSignup = function UserSignup() {
  return import('../../components/user/user-signup.vue' /* webpackChunkName: "components/user-signup" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplatePrintTemplateSvgsCancelledImage = function PrintTemplatePrintTemplateSvgsCancelledImage() {
  return import('../../components/print-template/print-template-svgs/cancelledImage.vue' /* webpackChunkName: "components/print-template-print-template-svgs-cancelled-image" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplatePrintTemplateSvgsConsolidatedLogo = function PrintTemplatePrintTemplateSvgsConsolidatedLogo() {
  return import('../../components/print-template/print-template-svgs/consolidatedLogo.vue' /* webpackChunkName: "components/print-template-print-template-svgs-consolidated-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplatePrintTemplateSvgsSwiggyLogo = function PrintTemplatePrintTemplateSvgsSwiggyLogo() {
  return import('../../components/print-template/print-template-svgs/swiggyLogo.vue' /* webpackChunkName: "components/print-template-print-template-svgs-swiggy-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplatePrintTemplateSvgsWhatsappLogo = function PrintTemplatePrintTemplateSvgsWhatsappLogo() {
  return import('../../components/print-template/print-template-svgs/whatsappLogo.vue' /* webpackChunkName: "components/print-template-print-template-svgs-whatsapp-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};
export var PrintTemplatePrintTemplateSvgsZomatoLogo = function PrintTemplatePrintTemplateSvgsZomatoLogo() {
  return import('../../components/print-template/print-template-svgs/zomatoLogo.vue' /* webpackChunkName: "components/print-template-print-template-svgs-zomato-logo" */).then(function (c) {
    return wrapFunctional(c.default || c);
  });
};

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options;
  }
  var propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {});
  return {
    render: function render(h) {
      var attrs = {};
      var props = {};
      for (var key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key];
        } else {
          attrs[key] = this.$attrs[key];
        }
      }
      return h(options, {
        on: this.$listeners,
        attrs: attrs,
        props: props,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    }
  };
}